import { UpdateState, updateGroupedConnections } from "../../app/networkSlice";
import { AppDispatch } from "../../app/store";
import { RingfencedElement } from "../../model/viewModel/ringfencedElement";

export const applyPoleChange = (
  ringfencedFiltered: RingfencedElement[],
  poleStatus: string,
  dispatchRedux: AppDispatch,
): void => {
  const updateStates: UpdateState[] = [];

  ringfencedFiltered.forEach((p) => {
    if (p.pole && p.pole.status !== poleStatus) {
      updateStates.push({
        id: p.id,
        name: "pole",
        value: { ...p.pole, status: poleStatus },
      });
    }
  });

  if (updateStates.length) {
    dispatchRedux(updateGroupedConnections(updateStates));
  }
};

export const applyPotEndChange = (
  ringfencedFiltered: RingfencedElement[],
  potEndStatus: string,
  dispatchRedux: AppDispatch,
): void => {
  const updateStates: UpdateState[] = [];

  ringfencedFiltered.forEach((p) => {
    if (p.potEnds && p.potEnds.some((q: any) => q.status !== potEndStatus)) {
      updateStates.push({
        id: p.id,
        name: "potEnds",
        value: p.potEnds.map((q: any) => ({ ...q, status: potEndStatus })),
      });
    }
  });

  if (updateStates.length) {
    dispatchRedux(updateGroupedConnections(updateStates));
  }
};

export const applyLinkBoxChange = (
  ringfencedFiltered: RingfencedElement[],
  linkBoxStatus: string,
  dispatchRedux: AppDispatch,
): void => {
  const updateStates: UpdateState[] = [];

  ringfencedFiltered.forEach((p) => {
    if (p.linkBox && p.linkBox.status !== linkBoxStatus) {
      updateStates.push({
        id: p.id,
        name: "linkBox",
        value: { ...p.linkBox, status: linkBoxStatus },
      });
    }
  });

  if (updateStates.length) {
    dispatchRedux(updateGroupedConnections(updateStates));
  }
};
